module.exports = __webpack_public_path__ + "images/bb0cb391bc9fb2fc4fa75a42a2be123fmanufacturing.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/manufacturing.png
// module id = zV3i
// module chunks = 0